const facebookShare = (link, title = '') => {
    FB.ui({
        method: 'share',
        href: link
    });
};

const twitterShare = (link, title = '') => {
    window.open(`https://twitter.com/intent/tweet?text=${encodeURI(link)}`, 'sharer', 'toolbar=0,status=0,width=648,height=395')
};
const whatsappShare = (link, title = '') => {
    const shareUtm = '?utm_source=whatsapp&utm_medium=whatsappshare&utm_campaign=sport1';
    let urlPrefix = 'https://web.whatsapp.com/send?text=';
    if (mobileCheck()) {
        urlPrefix = 'whatsapp://send?text='
    }
    const url = `${urlPrefix}${encodeURI(link)}${shareUtm}`;

    window.open(url)
};

const gmailShare = (link, title = '') => {
    let subject = jQuery('h1').text();
    if (title) {
        subject = title;
    }
    subject = subject.trim();

    let url = `mailto:?subject=${subject}&body=${link}`;

    const mail = document.createElement("a");
    mail.href = url;
    mail.target = '_blank';
    mail.click();
};

const copyShare = (link, title = '') => {
    let dummy = document.createElement('input');
    document.body.appendChild(dummy);
    dummy.value = link;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);

};

const commentsShare = (link = '', title = '') => {
    document.querySelector('#comments_anchor').scrollIntoView({ behavior: 'smooth' });
};


const sharers = {
    comments: {
      sharer: commentsShare
    },
    facebook: {
        sharer: facebookShare
    },
    twitter: {
        sharer: twitterShare
    },
    whatsapp: {
        sharer: whatsappShare
    },
    gmail: {
        sharer: gmailShare
    },
    copy: {
        sharer: copyShare
    }
};

jQuery(document).ready(($) => {


    let $socialIcons = $('.single-post .social .social-icon');

    // $socialIcons.click(function () {
    //     let id = $(this).attr('id');
    //     share(window.location.href, id);
    // })

});

function createShareLink() {

    let link = `https://your_subdomain.page.link/?link=your_deep_link&apn=package_name[&amv=minimum_version][&afl=fallback_link]`
}

export function share(link, medium, title = '') {
    const sharer = sharers[medium];

    if (sharer) {
        sharer.sharer(link, title);
    }
}